<template lang="html">
    <el-button class="cancelButton whiteButton" @click="back">{{txt}}</el-button>
</template>

<script>
export default {
    props: {
        txt: {
            type: String,
            default: 'Annuler'
        }
    },
    methods: {
        back() {
            this.$router.go(-1);
        }
    }
};
</script>

<style lang="css">

.cancelButton {
/*    color: #333333 !important;
    background-color: white !important;
    font-family: worksans, Arial, "Helvetica Neue", Helvetica, sans-serif;
    font-size: 18px !important;
    border: none !important;
    line-height: 18px !important;
    padding: 15px 30px 10px !important;
*/    margin: 6px 8px 50px 8px;
}
</style>



// WEBPACK FOOTER //
// src/components/ui/cancel-back.vue